// Display helpers for the dashboard's Reservations table.

/** Firestore Timestamp | {seconds} | Date | date string → Date (or null). */
export function toDateValue(v) {
  if (v === null || v === undefined || v === "") return null;
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
  if (typeof v.toDate === "function") return v.toDate();
  if (typeof v.seconds === "number") return new Date(v.seconds * 1000);
  if (typeof v._seconds === "number") return new Date(v._seconds * 1000);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** en-AU "Thu 05/11/2026" (DD/MM/YYYY with weekday). */
export function formatAuDate(v) {
  const d = toDateValue(v);
  if (!d) return "";
  const weekday = d.toLocaleDateString("en-AU", { weekday: "short" });
  const date = d.toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" });
  return `${weekday} ${date}`;
}
